// src/features/files/utils/previewKind.js
// How a file can be shown in the browser: 'pdf', 'image', 'video' or 'other'.
// Falls back to the extension when the stored MIME type is missing or generic
// (browsers often report .mkv as "" or application/octet-stream).

const IMAGE_EXT = /\.(jpe?g|png|gif|webp|bmp|svg)$/i;
const VIDEO_EXT = /\.(mp4|m4v|webm|ogv|mov|mkv)$/i;

export function getPreviewKind(filetype, filename) {
  const type = filetype || '';
  const name = filename || '';
  if (type === 'application/pdf' || /\.pdf$/i.test(name)) return 'pdf';
  if (type.startsWith('image/') || IMAGE_EXT.test(name)) return 'image';
  if (type.startsWith('video/') || VIDEO_EXT.test(name)) return 'video';
  return 'other';
}

export const isVideoFile = (filetype, filename) => getPreviewKind(filetype, filename) === 'video';
